import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/getLiteral';
import { SectionList } from '@Sage/ssm-web5';

import './styles.scss';

const ImplementationTable = ({
    list = [],
    listLoading,
    onClickRow = () => null,
    onToggleFavorite = () => null,
}) => {
    const getFavoriteRows = useCallback((rowData) => {
        if (rowData?.length === 0) return;

        const favoriteRows = rowData.reduce((obj, current) => {
            if (!obj?.code) obj.code = {};
            if (!obj?.code?.rows) obj.code.rows = {};
            if (current) {
                obj.code.rows[String(current.id)] = Boolean(current.favorite);
            }
            return obj;
        }, {});

        return favoriteRows;
    }, []);

    const columns = useMemo(
        () => [
            {
                colId: 'code',
                field: 'code',
                headerName: t('cfm_label_name'),
                pinned: 'left',
                cellRenderer: 'avatarCell',
                cellRendererParams: {
                    bold: true,
                    hoverLink: true,
                    isSquared: true,
                    imageSize: 'big',
                    favorite: {
                        onChange: ({ data }) => onToggleFavorite(data?.id, data?.favorite),
                        isAlwaysVisible: true,
                    },
                    onClick: ({ data }) => onClickRow(data.id),
                },
                suppressSizeToFit: true,
                width: 250,
                resizable: true,
            },
            {
                colId: 'licenseEditionCodeDescription',
                field: 'licenseEditionCodeDescription',
                headerName: t('cfm_label_plan'),
                cellRenderer: 'textCell',
                cellRendererParams: {
                    onClick: ({ data }) => onClickRow(data.id),
                },
                suppressSizeToFit: true,
                width: 150,
                resizable: true,
            },
            {
                colId: 'server',
                field: 'server',
                headerName: t('cfm_label_server'),
                cellRenderer: 'textCell',
                cellRendererParams: {
                    onClick: ({ data }) => onClickRow(data.id),
                },
                suppressSizeToFit: true,
                resizable: true,
            },
            {
                colId: 'users',
                field: 'users',
                headerName: t('cfm_label_users'),
                cellRenderer: 'textCell',
                cellRendererParams: {
                    onClick: ({ data }) => onClickRow(data.id),
                },
                width: 100,
                suppressSizeToFit: true,
                resizable: true,
            },
            {
                colId: 'partnerImplementation',
                field: 'partnerImplementation',
                headerName: t('cfm_label_partner'),
                cellRenderer: 'textCell',
                cellRendererParams: {
                    onClick: ({ data }) => onClickRow(data.id),
                },
                suppressSizeToFit: false,
                resizable: true,
            },
        ],
        [onClickRow, onToggleFavorite],
    );

    return (
        <div className="impl-table-content">
            <SectionList
                id="impl-list"
                columns={columns}
                rows={list}
                isLoading={listLoading}
                headerHeight={40}
                rowHeight={40}
                getFavoriteRows={getFavoriteRows}
                useSort
            />
        </div>
    );
};

ImplementationTable.propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({})),
    listLoading: PropTypes.bool,
    onClickRow: PropTypes.func,
    onToggleFavorite: PropTypes.func,
    searchText: PropTypes.string,
};

export default memo(ImplementationTable);
